import { ROLES } from '@/constants/roles';
import { DEV_DASHBOARD, DEV_PAGES } from './registry';
import { isDevEnvironment } from './services/environment';

export default isDevEnvironment ? [
  {
    path: '/dev',
    name: DEV_DASHBOARD.name,
    component: () => import('./views/dashboard.vue'),
    meta: { title: 'Тестовые экраны', layout: 'ui-design', accessList: Object.values(ROLES) },
  },
  ...DEV_PAGES.map((page) => ({
    path: page.path,
    name: page.name,
    component: () => import('./views/preview.vue'),
    props: { pageName: page.name },
    beforeEnter: (to, from, next) => next(!page.canOpen || page.canOpen() ? undefined : DEV_DASHBOARD),
    meta: { title: page.title, layout: 'ui-design', accessList: page.accessList },
  })),
] : [];
